import { useMutation } from '@tanstack/react-query'
import { blockBabysitter } from '../index'

const usePostBlockBabysitter = () =>
  useMutation({
    mutationFn: blockBabysitter,
  })

export default usePostBlockBabysitter
